import React, { useState } from 'react';
import './Contact.css';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';

const Contact = () => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [inputMethod, setInputMethod] = useState('type'); // 'type' or 'upload'
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFile(file);
      setInputMethod('upload');
    }
  };

  const handleRemoveFile = () => {
    setUploadedFile(null);
    setInputMethod('type');
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('sending');

    try {
      // Using Web3Forms - free form submission service
      const formKey = process.env.REACT_APP_WEB3FORMS_KEY || 'YOUR_WEB3FORMS_ACCESS_KEY';
      
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_key: formKey,
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          from_name: 'SoftLaabs Website Contact Form',
          to: 'softlaabs@softlaabs.org'
        })
      });

      const result = await response.json();

      if (result.success) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
        setUploadedFile(null);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    }
  };

  return (
    <div className="contact-page">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Get In Touch</h1>
          <p className="page-subtitle">
            Ready to start your project? Let's discuss how we can help
          </p>
        </div>
      </section>

      <section className="contact-content-section section">
        <div className="container">
          <div className="contact-wrapper-page">
            <div className="contact-info-page">
              <h3>Contact Information</h3>
              <div className="info-items">
                <div className="info-item-page">
                  <EmailIcon />
                  <div>
                    <h4>Email</h4>
                    <p>softlaabs@softlaabs.org</p>
                  </div>
                </div>
                <div className="info-item-page">
                  <PhoneIcon />
                  <div>
                    <h4>Phone</h4>
                    <p>+254 792560128</p>
                  </div>
                </div>
                <div className="info-item-page">
                  <LocationOnIcon />
                  <div>
                    <h4>Location</h4>
                    <p>Global Remote Services</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-form-page">
              {submitStatus === 'success' && (
                <div style={{
                  padding: '16px',
                  marginBottom: '20px',
                  backgroundColor: '#d4edda',
                  border: '1px solid #c3e6cb',
                  color: '#155724',
                  borderRadius: '3px'
                }}>
                  Thank you! Your message has been sent successfully. We'll get back to you soon.
                </div>
              )}
              {submitStatus === 'error' && (
                <div style={{
                  padding: '16px',
                  marginBottom: '20px',
                  backgroundColor: '#f8d7da',
                  border: '1px solid #f5c6cb',
                  color: '#721c24',
                  borderRadius: '3px'
                }}>
                  Sorry, there was an error sending your message. Please email us directly at softlaabs@softlaabs.org
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="form-group-page">
                  <label>Name</label>
                  <input 
                    type="text" 
                    name="name"
                    placeholder="Your Name" 
                    value={formData.name}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                <div className="form-group-page">
                  <label>Email</label>
                  <input 
                    type="email" 
                    name="email"
                    placeholder="your@email.com" 
                    value={formData.email}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                <div className="form-group-page">
                  <label>Subject</label>
                  <input 
                    type="text" 
                    name="subject"
                    placeholder="How can we help?" 
                    value={formData.subject}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                
                <div className="form-group-page">
                  <label>Project Details</label>
                  <div className="input-method-toggle">
                    <button
                      type="button"
                      className={`toggle-btn ${inputMethod === 'type' ? 'active' : ''}`}
                      onClick={() => {
                        setInputMethod('type');
                        setUploadedFile(null);
                      }}
                    >
                      Type Message
                    </button>
                    <button
                      type="button"
                      className={`toggle-btn ${inputMethod === 'upload' ? 'active' : ''}`}
                      onClick={() => setInputMethod('upload')}
                    >
                      Upload Proposal
                    </button>
                  </div>
                </div>

                {inputMethod === 'type' ? (
                  <div className="form-group-page">
                    <label>Message</label>
                    <textarea 
                      name="message"
                      placeholder="Tell us about your project, requirements, timeline, and budget..." 
                      value={formData.message}
                      onChange={handleInputChange}
                      required={!uploadedFile}
                      rows="6"
                    ></textarea>
                  </div>
                ) : (
                  <div className="form-group-page">
                    <label>Upload Proposal Document</label>
                    <div className="file-upload-area">
                      {!uploadedFile ? (
                        <label className="file-upload-label">
                          <input
                            type="file"
                            accept=".pdf,.doc,.docx,.txt"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                          />
                          <AttachFileIcon sx={{ fontSize: 40, color: '#2271b1', marginBottom: 1 }} />
                          <p className="upload-text">Click to upload or drag and drop</p>
                          <p className="upload-hint">PDF, DOC, DOCX, or TXT (max 10MB)</p>
                        </label>
                      ) : (
                        <div className="uploaded-file-info">
                          <AttachFileIcon sx={{ fontSize: 24, color: '#2271b1' }} />
                          <div className="file-details">
                            <p className="file-name">{uploadedFile.name}</p>
                            <p className="file-size">
                              {(uploadedFile.size / 1024).toFixed(2)} KB
                            </p>
                          </div>
                          <button
                            type="button"
                            className="remove-file-btn"
                            onClick={handleRemoveFile}
                            title="Remove file"
                          >
                            <DeleteIcon sx={{ fontSize: 20 }} />
                          </button>
                        </div>
                      )}
                    </div>
                    <p className="upload-note">
                      You can upload a detailed proposal document or switch back to typing your message.
                    </p>
                  </div>
                )}
                
                <Button 
                  variant="contained"
                  endIcon={<SendIcon />}
                  type="submit"
                  fullWidth
                  disabled={submitStatus === 'sending'}
                  sx={{
                    backgroundColor: '#2271b1',
                    color: '#ffffff',
                    fontWeight: '600',
                    padding: '12px 24px',
                    fontSize: '13px',
                    textTransform: 'none',
                    marginTop: '8px',
                    borderRadius: '3px',
                    boxShadow: '0 1px 0 #135e96',
                    '&:hover': {
                      backgroundColor: '#135e96'
                    },
                    '&:disabled': {
                      backgroundColor: '#8c8f94',
                      color: '#ffffff'
                    }
                  }}
                >
                  {submitStatus === 'sending' ? 'Sending...' : 'Send Message'}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
